/*
 * @see [Documentation](https://nuxt-graphql-middleware.dulnan.net/advanced/templates#operation-hashes)
 */
export const operationHashes = {
  "addConfigurableProductsToCart": "-JCVQdw39d",
  "addProductsToCart": "ynhFx6-jpz",
  "addProductsToWishlist": "7gJMPK6wOu",
  "addSimpleProductsToCart": "4BdD2K9peT",
  "applyCouponToCart": "gYK_jMqUyC",
  "blogDetail": "NFt0HzYMut",
  "blogOverview": "mI5uoHrtVH",
  "brands": "HwuDmUp9Ci",
  "changeCustomerPassword": "rxTRJKS2Zy",
  "checkToken": "xkG4JABSJJ",
  "cmsPage": "CdofwT061d",
  "createCustomer": "apWrLXYzJB",
  "createCustomerAddress": "8z_b7WtDp8",
  "createEmptyCart": "o1rQ4cxALE",
  "customer": "LR3lZrzl0V",
  "customerServicePage": "ByyaZ_CO1M",
  "deleteCustomerAddress": "Mne9mPdrvY",
  "esProductListCount": "8gpCCKKZMb",
  "esProducts": "9i00jTpFPJ",
  "esProductsByArticleCode": "UlJXkJnRAU",
  "esProductsBySearch": "U9cvfj9zx0",
  "esUrl": "fCB8qkijXE",
  "esUrlsGlobal": "1hp-bMnDej",
  "getAddressData": "W2oh9llt6n",
  "getCartStatus": "k3OWppLDEv",
  "getCustomerCart": "nl8vF76F9C",
  "getGiftwrappingProduct": "kvwC6eKM5d",
  "getGuestCart": "C2RIMK1J_t",
  "giftCardBalance": "SM12jKjpb_",
  "googleBusinessInformation": "kp_miGGSBP",
  "googleBusinessInformationToday": "2MbSoDPTx4",
  "gtmOrder": "vTuPqc6SK5",
  "kiyohStoreReviews": "EI0n0iqvNp",
  "layout": "UkkJPK624N",
  "login": "_ePma2Id0O",
  "logout": "iCh4bwb3uy",
  "mergeCarts": "Xb0uZ3ogSi",
  "order": "esB1wUxyZs",
  "orders": "DKr1LQTXVP",
  "pdp": "R5KsJUmthh",
  "placeOrder": "3O5gHrIk9_",
  "plp": "0vyMlMekD3",
  "plpPage": "VYLluMHKBK",
  "plpThemePage": "HqwX_jyw6r",
  "productStock": "FpKr1sPXsL",
  "quickSearch": "97qfDgMQUp",
  "redirectResolver": "KKs2UCMzuo",
  "removeCouponFromCart": "daz4Cw5Ypv",
  "removeItemFromCart": "8g8eLk3rWh",
  "removeProductsFromWishlist": "jfnCZ9yyW3",
  "requestPasswordResetEmail": "lnntgs51WM",
  "resetPassword": "IDSxEfEcc0",
  "restoreCart": "_oUCQJwPPW",
  "search": "N7shpUn0Oz",
  "setBillingAddressOnCart": "ftEx7rivSF",
  "setGuestEmailOnCart": "XXasXb2cpQ",
  "setPaymentMethodOnCart": "u-1MXhukk0",
  "setShippingAddressesOnCart": "7SDaf_Ez31",
  "setShippingMethodsOnCart": "rmNqU9qJsC",
  "stock": "1iZvWY2ZLD",
  "storeConfig": "IXsgozh6cJ",
  "subscribeEmailToNewsletter": "p2m_3Afiay",
  "updateCartItems": "CcvseAPrfD",
  "updateCustomer": "n-CrHEqanv",
  "updateCustomerAddress": "ehX4lRzEOb",
  "updateCustomerEmail": "A00VtUobhL",
  "wishlistProduct": "uH-lHz0922",
  "wishlistProducts": "3WhUrwoKK0"
}